<template>
  <div
    class="pagoda-select-tree"
    :class="{
      'advanced-search': advancedSearch
    }"
  >
    <el-select
      popper-class="pagoda-select-tree-popper"
      :value="selectValue"
      :filterable="filterable"
      :filter-method="handleFilter"
      :multiple="tags"
      v-bind="selectProps"
      v-on="selectEvents"
      @remove-tag="handleRemoveTag"
      @visible-change="handleVisibleChange"
      @clear="handleClear"
      ref="select"
    >
      <el-option :value="null">
        <el-tree
          :node-key="valueKey"
          :data="data"
          v-bind="treeProps"
          v-on="treeEvents"
          :default-checked-keys="defaultChecked"
          :default-expanded-keys="defaultExpanded"
          :show-checkbox="multiple"
          :filter-node-method="filterNode"
          @check-change="handleCheckChange"
          @node-click="handleNodeClick"
          ref="tree"
        >
          <span
            class="pagoda-select-tree-node"
            slot-scope="{ data }"
          >
            <span
              :class="{
                'is-checked': valueKey in data && isNodeChecked(data[valueKey])
              }"
            >{{ data[labelKey] }}</span>
          </span>
        </el-tree>
      </el-option>
    </el-select>
    <span
      class="el-input__suffix el-input__suffix-more"
      v-if="advancedSearch"
      @click.stop="dialog.visible = true"
    >
      <span class="el-input__suffix-inner">
        <i class="el-select__caret el-input__icon el-icon-more"></i>
      </span>
    </span>
    <el-dialog
      v-if="advancedSearch"
      :visible.sync="dialog.visible"
      v-bind="dialogProps"
      append-to-body
    >
      <slot
        :dialog="dialog"
        name="advanced-search"
      ></slot>
    </el-dialog>
  </div>
</template>

<script>
import { getEmptyArray, getEmptyObject, isArray } from '../../utils'

export default {
  name: 'SelectTree',
  props: {
    labelKey: {
      type: String,
      default: 'label'
    },
    valueKey: {
      type: String,
      default: 'value'
    },
    value: {
      required: true
    },
    onlyLeaf: {
      type: Boolean,
      default: true
    },
    data: {
      type: Array,
      default: getEmptyArray
    },
    multiple: {
      type: Boolean,
      default: false
    },
    isObjectValue: {
      type: Boolean,
      default: false
    },
    filterable: {
      type: Boolean,
      default: false
    },
    allSelectText: {
      type: String,
      default: ''
    },
    treeProps: {
      type: Object,
      default: getEmptyObject
    },
    selectProps: {
      type: Object,
      default: getEmptyObject
    },
    selectEvents: {
      type: Object,
      default: getEmptyObject
    },
    treeEvents: {
      type: Object,
      default: getEmptyObject
    },
    tags: {
      type: Boolean,
      default: false
    },
    dialogProps: {
      type: Object,
      default: function() {
        return {
          title: '高级搜索',
          width: '750px'
        }
      }
    }
  },
  data() {
    return {
      dialog: {
        visible: false
      }
    }
  },
  created() {
    this.checkedNodes = this.multiple ? [] : {}
    this.hasValueNodesNum = 0
    this.valueToNode = {}
    this.labelToValue = {}

    this.getDataMap(this.data)
  },
  mounted() {
    this.tree = this.$refs.tree
  },
  methods: {
    handleClear() {
      if (this.multiple) {
        // 清空tree checkbox 的选中状态
        if (this.treeProps.lazy || this.isObjectValue) {
          this.value.forEach(removeValue =>
            this.tree.setChecked(removeValue[this.valueKey], false, true)
          )
        } else {
          this.value.forEach(removeValue => this.tree.setChecked(removeValue, false, true))
        }

        if (this.tags || this.treeProps.lazy || this.isObjectValue) {
          this.$emit('input', [])
        } else {
          this.$emit('input', '')
        }
      } else {
        this.$emit('input', '')
      }
    },
    isNodeChecked(nodeVal) {
      if (this.treeProps.lazy || this.isObjectValue) {
        if (this.multiple) {
          return this.value.find(node => node[this.valueKey] === nodeVal)
        } else {
          return this.value[this.valueKey] === nodeVal
        }
      } else {
        if (this.multiple) {
          return this.value.includes(nodeVal)
        } else {
          return this.value === nodeVal
        }
      }
    },
    handleRemoveTag(tag) {
      if (this.allSelectText && tag === this.allSelectText) {
        this.handleClear()
        return
      }

      const removeValue = this.labelToValue[tag]
      const newValue = this.value.filter(val => {
        if (this.isObjectValue || this.treeProps.lazy) {
          return val[this.valueKey] !== removeValue
        } else {
          return val !== removeValue
        }
      })

      this.tree.setChecked(removeValue, false, true)
      this.byClick = true
      this.$emit('input', newValue)
    },
    handleCheckChange(data) {
      if (!this.multiple) return

      const checkedNodes = this.tree.getCheckedNodes(this.onlyLeaf)
      this.byClick = true

      if (this.treeProps.lazy || this.isObjectValue) {
        this.$emit('input', checkedNodes)
      } else {
        this.$emit(
          'input',
          checkedNodes.map(node => node[this.valueKey])
        )
      }
    },
    handleNodeClick(node) {
      console.log(node)
      if (this.valueKey in node && !this.multiple) {
        if (node[this.childrenKey] && node[this.childrenKey].length && this.onlyLeaf) return

        if (this.treeProps.lazy || this.isObjectValue) {
          this.$emit('input', node)
        } else {
          this.$emit('input', node[this.valueKey])
        }
        this.byClick = true
        this.$refs.select.toggleMenu()
        // this.$nextTick(this.$refs.select.focus)
      }
    },
    handleVisibleChange(visible) {
      if (visible) {
        this.handleFilter('')
      }
    },
    handleFilter(val) {
      this.$refs.tree.filter(val)
    },
    filterNode(value, data) {
      if (!value) return true
      return data[this.labelKey].indexOf(value) !== -1
    },
    getDataMap(nodes) {
      nodes.forEach(node => {
        if (this.valueKey in node) {
          this.hasValueNodesNum++
          this.valueToNode[node[this.valueKey]] = node
          this.labelToValue[node[this.labelKey]] = node[this.valueKey]
        }

        if (node[this.childrenKey] && node[this.childrenKey].length) {
          this.getDataMap(node[this.childrenKey])
        }
      })
    },
    getCheckedNodes() {
      return this.checkedNodes
    }
  },
  watch: {
    value(val) {
      if (!this.byClick) {
        const checkedNodes = this.tree.getCheckedNodes()

        if (this.multiple) {
          checkedNodes.forEach(node => {
            if (!val.includes(node[this.valueKey]))
              this.tree.setChecked(node[this.valueKey], false, true)
          })
        } else if (checkedNodes) {
          if (val !== checkedNodes[this.valueKey]) this.tree.setChecked(val, false, true)
        }
      }
      this.byClick = false

      this.$emit('change', val)
    },
    data(val) {
      this.hasValueNodesNum = 0

      this.getDataMap(val)
    }
  },
  computed: {
    childrenKey() {
      return (this.treeProps.props && this.treeProps.props.children) || 'children'
    },
    advancedSearch() {
      return !!this.$scopedSlots['advanced-search']
    },
    // value 变化的时候触发selectValue更新 同时更新checkedNodes缓存
    selectValue() {
      if (this.treeProps.lazy || this.isObjectValue) {
        if (this.multiple) {
          const selectValue = this.value.map(item => item[this.labelKey])

          return !this.tags ? selectValue.join(',') : selectValue
        } else {
          return this.value[this.labelKey]
        }
      } else if (this.data.length) {
        if (this.multiple) {
          if (!this.value) return this.value

          let selectValue = [],
            checkedNodes = []

          this.value.forEach(val => {
            const node = this.valueToNode[val]

            if (node) {
              selectValue.push(node[this.labelKey])
              checkedNodes.push(node)
            }
          })

          this.checkedNodes = checkedNodes

          // 全选
          if (this.hasValueNodesNum === this.value.length && this.allSelectText) {
            selectValue = [this.allSelectText]
          }

          return !this.tags ? selectValue.join(',') : selectValue
        } else {
          const node = this.valueToNode[this.value]
          this.checkedNodes = node

          return node && node[this.labelKey]
        }
      }
    },
    defaultChecked() {
      if (this.treeProps.lazy || this.isObjectValue) {
        if (this.multiple) {
          return this.value.map(item => item[this.valueKey])
        } else {
          return [this.value[this.valueKey]]
        }
      } else {
        return this.multiple && isArray(this.value) ? this.value : [this.value]
      }
    },
    defaultExpanded() {
      if (!this.treeProps.lazy) {
        return this.multiple && isArray(this.value) ? this.value : [this.value]
      }
    }
  }
}
</script>
